import { Component, AfterViewInit, OnDestroy } from "@angular/core";

@Component({
    standalone: false,
    selector: 'cbc-model-agreement-tax-matters',
    templateUrl: './cbc-model-agreement-tax-matters.component.html',
    styleUrls: ['./cbc-model-agreement-tax-matters.component.scss']
})

export class CbcModelAgreementTaxMattersComponent implements AfterViewInit, OnDestroy {

  activeSection: string | null = null;
  observer!: IntersectionObserver;

  scrollToId(id: string) {
    const elmnt = document.getElementById(id);
    elmnt.scrollIntoView();

    this.activeSection = id;
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.initIntersectionObserver();
    }, 100);
  }

  initIntersectionObserver() {
    const scrollContainer = document.querySelector('mat-sidenav-container');

    const sections = document.querySelectorAll('[id^="c"], [id^="chapter"], [id^="article"]');

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = (entry.target as HTMLElement).id;
          }
        });
      },
      {
        root: scrollContainer,
        threshold: [0.25, 0.5, 0.75],
        rootMargin: '0px 0px -75% 0px'
      }
    );

    sections.forEach(section => this.observer.observe(section));
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
